// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentfulBreakoutBanner-module__wrapper__ApybVQa","logoWrapper":"ContentfulBreakoutBanner-module__logoWrapper__ycv3MXk"};